var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _circle, _circle2, _path70, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 280,
    viewBox: "0 0 203 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 3.2124C97.1667 27.0561 102.5 78.9867 102.5 95.9602",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 2C107.333 25.8437 102 77.7743 102 94.7478",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2C28.8519 16.1567 86.4444 63.376 102 139",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199 4.4248C172.954 18.3309 117.089 64.7145 102 139",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2C42.5939 21.8024 98.6255 76.6832 102 137.788",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190 2C162.089 21.9792 105.413 77.35 102 139",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2C51.689 19.8615 102.852 72.025 101.989 137.788",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179 2C152.973 19.8615 101.137 72.025 102.011 137.788",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39 2C62.3333 20.1858 107.5 72.4398 101.5 135.969",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.043 2C141.71 20.1858 96.5434 72.4398 102.543 135.969",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149 2C132.378 20.6889 99.7311 71.8287 102.125 126.876",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52 2C69.7045 17.4788 104.463 64.1243 101.862 126.876",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2C65 2 102.798 39.5841 101.987 114.752",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139 2C139 2 101.202 39.5841 102.013 114.752",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 2.6062C88.6667 16.3466 101.2 56.1938 102 105.659",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 2C115.333 15.7404 102.8 55.5876 102 105.053",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2 279L2.00001 2.99999",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M201 278L201 1.99999",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83191 131.124C19.1918 134.847 54.823 142.292 66.4691 142.292",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2 152.761C18.3599 149.039 53.9911 141.594 65.6372 141.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2C11.7133 39.4835 44.112 119.879 96 141.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6637 277C13.2051 240.641 45.0303 162.657 96 141.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.1472C15.587 58.6667 53.2425 136.883 95.1681 141.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2 264.437C15.7083 225.474 53.7 146.359 96 141.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2 35.5026C14.2553 71.3629 50.0463 142.783 95.1681 141.579",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2 249.081C14.2553 212.749 50.0463 140.39 95.1681 141.609",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2 53.6498C14.4779 86.2217 50.331 149.272 93.9203 140.896",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2 229.599C14.4779 197.027 50.331 133.977 93.9203 142.352",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2 207.203C14.8231 183.999 49.9116 138.427 87.6814 141.768",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2 71.7971C12.6205 96.5115 44.6254 145.033 87.6814 141.401",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2 89.9442C2 89.9442 27.7876 142.708 79.3628 141.576",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2 193.244C2 193.244 27.7876 140.48 79.3628 141.612",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41589 114.373C11.8436 122.981 39.184 140.477 73.1238 141.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2 168.815C11.4277 160.206 38.7681 142.711 72.7079 141.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M200.168 130.124C183.808 133.847 148.177 141.292 136.531 141.292",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M201 151.761C184.64 148.039 149.009 140.594 137.363 140.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M201 1C191.287 38.4835 158.888 118.879 107 140.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M199.336 276C189.795 239.641 157.97 161.657 107 140.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M201 19.1472C187.413 57.6667 149.758 135.883 107.832 140.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M201 263.437C187.292 224.474 149.3 145.359 107 140.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M201 34.5026C188.745 70.3629 152.954 141.783 107.832 140.579",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M201 248.081C188.745 211.749 152.954 139.39 107.832 140.609",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M201 52.6498C188.522 85.2217 152.669 148.272 109.08 139.896",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M201 228.599C188.522 196.027 152.669 132.977 109.08 141.352",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M201 206.203C188.177 182.999 153.088 137.427 115.319 140.768",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M201 70.7971C190.38 95.5115 158.375 144.033 115.319 140.401",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M201 88.9442C201 88.9442 175.212 141.708 123.637 140.576",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M201 192.244C201 192.244 175.212 139.48 123.637 140.612",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M200.584 113.373C191.156 121.981 163.816 139.477 129.876 140.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M201 167.815C191.572 159.206 164.232 141.711 130.292 140.594",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199.15 131.854C182.442 135.379 146.053 142.43 134.159 142.43",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M200 152.344C183.292 148.819 146.903 141.769 135.009 141.769",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 276.805C97.1667 253.31 102.5 202.137 102.5 185.411",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M110 278C107.333 254.504 102 203.332 102 186.606",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M2 278C28.8519 264.05 86.4444 217.52 102 143",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M199 275.611C172.954 261.908 117.089 216.201 102 143",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M15 278C42.5939 258.487 98.6255 204.407 102 144.195",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M190 278C162.089 258.312 105.413 203.75 102 143",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M26 278C51.689 260.399 102.852 208.997 101.989 144.195",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M179 278C152.973 260.399 101.137 208.997 102.011 144.195",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M39 278C62.3333 260.08 107.5 208.588 101.5 145.987",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M165.043 278C141.71 260.08 96.5434 208.588 102.543 145.987",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M149 278C132.378 259.584 99.7311 209.191 102.125 154.947",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M52 278C69.7045 262.747 104.463 216.783 101.862 154.947",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M65 278C65 278 102.798 240.965 101.987 166.894",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M139 278C139 278 101.202 240.965 102.013 166.894",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 277.403C88.6667 263.863 101.2 224.597 102 175.854",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 278C115.333 264.46 102.8 225.195 102 176.451",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8,
    strokeWidth: 0.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M2 278L200 278",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(1 0 0 -1 2.5 277.5)",
    fill: "#EEEBE7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(1 0 0 -1 200.5 277.5)",
    fill: "#EEEBE7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L200 2",
    stroke: "#EEEBE7",
    strokeOpacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#EEEBE7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.5,
    cy: 2.5,
    r: 2.5,
    fill: "#EEEBE7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBackground);
export default __webpack_public_path__ + "static/media/card-background.8c5bc70fec0b00000307650811365803.svg";
export { ForwardRef as ReactComponent };